<template>
    <div>
      <div class="upload-container">
        <p>Upload het camt bestand</p>
        <input type="file" ref="fileInput" @change="handleFileSelection($event)" style="display: none;" />
        <button @click="triggerFileInput" class="btn">Selecteer bestand</button>
        <button @click="submitFile" :disabled="!file" class="btn" :class="{ disabled: !file }">Upload</button>
      </div>
    </div>
</template>

<script>

export default {
  computed: {
    user: {
      get: function () {
        return this.$store.state.user
      },
    },
  },
  data() {
    return {
      file: null,
    }
  },
  mounted() {
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click()
    },
    handleFileSelection(event) {
      this.file = event.target.files[0]
    },
    submitFile() {
      if (!this.file) return

      const formData = new FormData()
      formData.append('file', this.file)
      this.$axios.post('/bookkeeping/camt/upload', formData, {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        },
      }).then(response => {
        // handle response
      }).catch(error => {
        // handle error
        console.error('Error uploading file:', error)
      })
    },
  },
}
</script>

<style scoped>
.upload-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 10px;
    max-width: 400px;
    background-color: #f9f9f9;
}

.upload-container p {
    font-size: 18px;
    margin-bottom: 5px;
}

.btn {
    padding: 10px 20px;
    margin: 10px;
    border: none;
    border-radius: 5px;
    background-color: #007bff;
    color: white;
    cursor: pointer;
    font-size: 16px;
}

.btn.disabled {
    background-color: #ccc;
    cursor: not-allowed;
}
</style>
